<template>
  <v-dialog
    v-model="dialog"
    max-width="800"
    persistent
  >
    <v-card>
      <BarTitleDialog
        :title="isEdit ? 'Editar Tarifário' : 'Novo Tarifário'"
        @close="close()"
      />

      <v-card-text class="pt-4">
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="form.description"
              label="Descrição"
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="form.date_start"
              label="Início de Vigência"
              outlined
              dense
              hide-details
              type="date"
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="form.date_end"
              label="Fim de Vigência"
              outlined
              dense
              hide-details
              type="date"
            />
          </v-col>
        </v-row>

        <v-divider class="my-4" />

        <div class="subtitle-1 mb-1">
          Preços por Categoria de Quarto
        </div>
        <div class="caption grey--text mb-3">
          Tarifa FDS aplica-se em sextas e sábados. Tarifas especiais sobrescrevem ambas nas datas configuradas.
        </div>

        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th>CATEGORIA</th>
                <th style="width: 160px;">
                  DIÁRIA (R$)
                </th>
                <th style="width: 160px;">
                  FDS / FER. (R$)
                </th>
                <th
                  v-if="isEdit"
                  style="width: 56px;"
                  class="text-center"
                >
                  ESPECIAIS
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in form.items"
                :key="index"
              >
                <td>{{ item.category_name }}</td>
                <td>
                  <vuetify-money
                    v-model="item.value"
                    dense
                    outlined
                    hide-details
                    class="my-1"
                  />
                </td>
                <td>
                  <vuetify-money
                    v-model="item.weekend_value"
                    dense
                    outlined
                    hide-details
                    placeholder="—"
                    class="my-1"
                  />
                </td>
                <td
                  v-if="isEdit"
                  class="text-center"
                >
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        small
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        @click="openSpecialRates(item)"
                      >
                        <v-icon small>
                          {{ icons.mdiCalendarMultiple }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Tarifas Especiais</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <div
          v-if="!isEdit"
          class="caption grey--text mt-2"
        >
          Salve o tarifário para configurar tarifas especiais por categoria.
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="close()"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="primary"
          :loading="loading"
          @click="save()"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>

    <RatePlanSpecialRatesModal
      v-model="specialRatesDialog"
      :rate-plan-id="form.id"
      :category="selectedCategory"
    />
  </v-dialog>
</template>

<script>
import { mdiCalendarMultiple } from '@mdi/js'
import { mapActions } from 'vuex'
import BarTitleDialog from '@/components/BarTitleDialog.vue'
import RatePlanSpecialRatesModal from './RatePlanSpecialRatesModal.vue'

export default {
  components: { BarTitleDialog, RatePlanSpecialRatesModal },

  props: {
    value: { type: Boolean, default: false },
    editedItem: { type: Object, default: null },
    categories: { type: Array, default: () => [] },
  },

  data: () => ({
    loading: false,
    specialRatesDialog: false,
    selectedCategory: null,
    form: {
      description: '',
      date_start: null,
      date_end: null,
      items: [],
    },
    icons: { mdiCalendarMultiple },
  }),

  computed: {
    dialog: {
      get() { return this.value },
      set(v) { this.$emit('input', v) },
    },
    isEdit() {
      return !!this.editedItem?.id
    },
  },

  watch: {
    value(val) {
      if (val) this.initForm()
    },
  },

  methods: {
    ...mapActions('rate_plan', ['store', 'update']),

    initForm() {
      if (this.isEdit) {
        this.form = {
          id: this.editedItem.id,
          description: this.editedItem.description,
          date_start: this.editedItem.date_start,
          date_end: this.editedItem.date_end,
          items: this.categories.map(cat => {
            const existing = (this.editedItem.items || []).find(i => i.room_category_id === cat.id)

            return {
              room_category_id: cat.id,
              category_name: cat.description,
              value: existing ? existing.value : 0,
              weekend_value: existing ? existing.weekend_value : null,
            }
          }),
        }
      } else {
        this.form = {
          description: '',
          date_start: null,
          date_end: null,
          items: this.categories.map(cat => ({
            room_category_id: cat.id,
            category_name: cat.description,
            value: 0,
            weekend_value: null,
          })),
        }
      }
    },

    openSpecialRates(item) {
      this.selectedCategory = { id: item.room_category_id, description: item.category_name }
      this.specialRatesDialog = true
    },

    save() {
      this.loading = true
      const action = this.isEdit ? this.update(this.form) : this.store(this.form)
      action
        .then(res => {
          this.$emit('saved', res.data)
          this.$toast.success('Tarifário salvo com sucesso!')
          this.close()
        })
        .catch(() => {})
        .finally(() => { this.loading = false })
    },

    close() {
      this.dialog = false
    },
  },
}
</script>
